import React from "react";
import "./Skills.css";

const skills = [
  {
    id: "01",
    img: "https://i.ibb.co/XxLJgfq/html.jpg",
    title: "HTML",
  },
  {
    id: "02",
    img: "https://i.ibb.co/pP1zsKS/css.png",
    title: "CSS",
  },
  {
    id: "03",
    img: "https://i.ibb.co/8KWShGJ/bootstrap.jpg",
    title: "Bootstrap",
  },
  {
    id: "04",
    img: "https://i.ibb.co/3NVwy1J/tailwind.png",
    title: "Tailwind.CSS",
  },
  {
    id: "05",
    img: "https://i.ibb.co/LgcMHXS/java.png",
    title: "Javascript",
  },
  {
    id: "06",
    img: "https://i.ibb.co/JC9VJsY/react.jpg",
    title: "React",
  },
  {
    id: "07",
    img: "https://i.ibb.co/VmCtmJf/materila.png",
    title: "Material-UI",
  },
  {
    id: "08",
    img: "https://i.ibb.co/QDBVhXw/dofirebase.png",
    title: "Firebase",
  },
  {
    id: "09",
    img: "https://i.ibb.co/f0wjM1k/node.png",
    title: "Node.js",
  },
  {
    id: "010",
    img: "https://i.ibb.co/ZYZY1hb/mongodb.jpg",
    title: "MongoDB",
  },
  {
    id: "011",
    img: "https://i.ibb.co/0DkCgHp/express.jpg",
    title: "Express.js",
  },
  {
    id: "02",
    img: "https://i.ibb.co/CtgdHxD/github.png",
    title: "Github",
  },
];

const Skills = () => {
  return (
    <div className="container skill-section">
      <div className="heading-section pb-4">
        <h4>My Skills</h4>
      </div>

      <div className="row">
        <div className="col-md-3 mt-4 skill">
          <div className="icon-box ">
            <i className="fa-brands fa-html5 fa-2x" style={{ color: "#ffbb2c" }}></i>
            <h3>Html</h3>
          </div>
        </div>
        <div className="col-md-3 mt-4 skill">
          <div className="icon-box">
            <i className="fa-brands fa-css3 fa-2x" style={{ color: "#5578ff" }}></i>
            <h3>Css</h3>
          </div>
        </div>
        <div className="col-md-3 mt-4 skill">
          <div className="icon-box">
            <i className="fa-brands fa-bootstrap fa-2x" style={{ color: "#8B12FC" }}></i>
            <h3>Bootstrap</h3>
          </div>
        </div>
        <div className="col-md-3 mt-4 skill">
          <div className="icon-box">
            <i className="fa-brands fa-css3 fa-2x" style={{ color: "#e80368" }}></i>
            <h3>Tailwind Css</h3>
          </div>
        </div>
        <div className="col-md-3 mt-4 skill">
          <div className="icon-box">
            <i className="fa-brands fa-js-square fa-2x" style={{ color: "#e361ff" }}></i>
            <h3>Javascript</h3>
          </div>
        </div>
        <div className="col-md-3 mt-4 skill">
          <div className="icon-box">
            <i className="fa-brands fa-react fa-2x" style={{ color: "#47aeff" }}></i>
            <h3>React.JS</h3>
          </div>
        </div>
        <div className="col-md-3 mt-4 skill">
          <div className="icon-box">
            <img
              className="skill-img-custom"
              src="https://i.ibb.co/w44Zg5x/redux-removebg-preview.png"
              alt=""
            />
            <h3>Redux</h3>
          </div>
        </div>
        <div className="col-md-3 mt-4 skill">
          <div className="icon-box">
            <img
              className="skill-img-custom"
              src="https://i.ibb.co/NYk922Z/firebase-w.png"
              alt=""
            />
            <h3>Firebase</h3>
          </div>
        </div>
        <div className="col-md-3 mt-4 skill">
          <div className="icon-box">
            <i className="fa-brands fa-node fa-2x" style={{ color: "#3E863B" }}></i>
            <h3>Node.JS</h3>
          </div>
        </div>
        <div className="col-md-3 mt-4 skill">
          <div className="icon-box">
            <img className="skill-img-custom" src="https://i.ibb.co/PTf1Zd4/express-w.png" alt="" />
            <h3>Express.JS</h3>
          </div>
        </div>
        <div className="col-md-3 mt-4 skill">
          <div className="icon-box">
            <img
              className="skill-img-custom"
              src="https://i.ibb.co/NT9jjXf/mo429m311-mongodb-logo-mongodb-logo-removebg-preview.png"
              alt=""
            />
            <h3>MongoDB</h3>
          </div>
        </div>
        <div className="col-md-3 mt-4 skill">
          <div className="icon-box">
            <i className="fa-brands fa-git-alt fa-2x" style={{ color: "#ff5828" }}></i>
            <h3>Git</h3>
          </div>
        </div>
        <div className="col-md-3 mt-4 skill">
          <div className="icon-box">
            <img
              className="skill-img-custom"
              src="https://i.ibb.co/svhTpMb/typescript.png"
              alt=""
            />
            <h3>TypeScript</h3>
          </div>
        </div>
        <div className="col-md-3 mt-4 skill">
          <div className="icon-box">
            <img
              className="skill-img-custom"
              style={{ width: "50px" }}
              src="https://i.ibb.co/12N7qg4/nextjs-removebg-preview.png"
              alt=""
            />
            <h3>Next JS</h3>
          </div>
        </div>
        <div className="col-md-3 mt-4 skill">
          <div className="icon-box">
            <img
              className="skill-img-custom "
              style={{ width: "50px" }}
              src="https://i.ibb.co/Psyf1gg/postgresql.png"
              alt=""
            />
            <h3>PostgreSQL</h3>
          </div>
        </div>
        <div className="col-md-3 mt-4 skill">
          <div className="icon-box">
            <img
              className="skill-img-custom"
              src="https://i.ibb.co/vhp2v68/prisma-logo.png"
              alt=""
            />
            <h3>Prisma</h3>
          </div>
        </div>
      </div>
      {/* <div className="row row-cols-1 row-cols-md-4 g-4">
                {skills?.map(skill=><div key={skill.id} className="col ">
                        <div className="main-div">
                    <img style={{height:'100px',width:'100px'}} src={skill.img} className="card-img-top skill-image" alt="..."/>
                    <div className="card-body">
                        <h5 className="card-title">{skill.title}</h5>
                        
                    </div>
                    </div>
                        



                        
                    </div>
                    )}
                
            </div> */}
    </div>
  );
};

export default Skills;
